import { FeeBasisDeterminationEnum } from "gen/model/feeBasisDeterminationEnum";
import { FeeChargeTimingEnum } from "gen/model/feeChargeTimingEnum";
import { FeeCreateAPIDataRequest } from "gen/model/feeCreateAPIDataRequest";
import React from "react";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormToggleButtonGroup,
  ToggleButton,
} from "shared/components/button/ToggleButton";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockHeader,
  ContentBlockTitle,
} from "shared/components/content/ContentBlock";
import { FormSelect } from "shared/components/input/select/Select";
import { SelectElement } from "shared/components/input/select/SelectOption";
import { enumKeys } from "shared/utils/EnumUtils";

interface FeeFormSectionInitialProps {
  control: Control<
    FeeCreateAPIDataRequest & {
      fee_eligible_for_true_up: boolean;
    }
  >;
  isDisabled?: boolean;
}

const FeeChargeTimingFormSelect: React.FC<{
  isDisabled?: boolean;
}> = ({ isDisabled }) => {
  const { t } = useTranslation(["fees", "enums"]);
  return (
    <FormToggleButtonGroup
      name="fee.initial_charge_timing"
      title={t("fees:chargeTiming.title")}
      isDisabled={isDisabled}
    >
      <ToggleButton value={FeeChargeTimingEnum.in_advance}>
        {t("enums:ChargeTimingEnum.in_advance")}
      </ToggleButton>
      <ToggleButton value={FeeChargeTimingEnum.in_arrears}>
        {t("enums:ChargeTimingEnum.in_arrears")}
      </ToggleButton>
    </FormToggleButtonGroup>
  );
};

const FeeBasisDeterminationFormSelect: React.FC<{
  isDisabled?: boolean;
}> = ({ isDisabled }) => {
  const { t } = useTranslation(["fees", "enums"]);

  const feeBasisTypeElements = enumKeys(
    FeeBasisDeterminationEnum,
  ).map<SelectElement>((feeBasisType) => ({
    value: feeBasisType,
    rich_value: t(`enums:FeeBasisDeterminationEnum.${feeBasisType}`),
  }));

  return (
    <FormSelect
      name="fee.initial_fee_basis_determination"
      title={t("fees:feeBasis")}
      elements={feeBasisTypeElements}
      isDisabled={isDisabled}
    />
  );
};

const FeeFormSectionInitialOverrides: React.FC<FeeFormSectionInitialProps> = ({
  isDisabled,
}) => {
  const { t } = useTranslation(["fees"]);
  return (
    <ContentBlock>
      <ContentBlockHeader>
        <ContentBlockTitle>
          {t("fees:feeForm.initialSectionOptionalOverrides")}
        </ContentBlockTitle>
      </ContentBlockHeader>
      <ContentBlockBody variant="form">
        <FeeChargeTimingFormSelect isDisabled={isDisabled} />
        <FeeBasisDeterminationFormSelect isDisabled={isDisabled} />
      </ContentBlockBody>
    </ContentBlock>
  );
};

export default FeeFormSectionInitialOverrides;
